module.exports = __webpack_public_path__ + "static/media/taste-of-weight-loss.a068f401.png";